import { UserProperties } from "./user.type";
import { EventParticipantProperties } from "./eventParticipant.type";
import { OfficeProperties } from "./office.type";
import { ProfileProperties } from "./profile.type";
import { EmployeeRoleProperties } from "./employeeRole.type";
import { MasterPositionProperties } from "./masterPosition.type";
import { FileProperties } from "./file.type";
import { BaseResponseProps } from "./config.type";
import { AgentBillingProperties } from "./agentBilling.type";
import { AgentFeeChargeProperties } from "./agentFeeCharge.type";
import { AgentCommissionProperties, GroupedCommission } from "./agentCommission.type";
import { GroupMemberProperties } from "./groupMember.type";
import { AlbumItem } from "./album.type";
import { AgentHistoryProperties } from "./agentHistory.type";

export enum EEmployeeRole {
	admin = "admin", // or super user
	admin_general_manager = "admin_general_manager",
	admin_manager = "admin_manager",
	admin_hq = "admin_hq", // or hq staff
	admin_finance_gm = "admin_finance_gm", // GM Finance
	admin_finance_manager = "admin_finance_manager", // Finance Manager
	admin_finance_staff = "admin_finance_staff",
	admin_blog = "admin_blog",

	franchise_owner = "franchise_owner",
	business_owner = "business_owner",
	manager_office = "manager_office",
	finance_office = "finance_office",
	admin_office = "admin_office",
	agent = "agent",
}
export const EMPLOYEE_ROLES_MAPPING = {
	// level 1
	admin: "HQ Super Admin",
	admin_general_manager: "HQ General Manager",
	admin_manager: "HQ Manager",
	admin_hq: "Admin HQ",
	admin_finance_gm: "HQ Finance GM",
	admin_finance_manager: "HQ Finance Manager",
	admin_finance_staff: "HQ Finance Staff",
	admin_blog: "HQ Admin Blog",

	// level 2
	franchise_owner: "Franchise Owner",
	business_owner: "Business Owner",
	manager_office: "Manager Office",
	finance_office: "Finance Office",
	admin_office: "Admin Office",

	// level 3
	agent: "Agent",
};

export const EMPLOYEE_ROLES_MAPPING_LONG = {
	admin: "HQ Super Admin",
	admin_general_manager: "HQ General Manager",
	admin_manager: "HQ Manager",
	admin_hq: "Admin HQ",
	admin_finance_gm: "HQ Finance GM",
	admin_finance_manager: "HQ Finance Manager",
	admin_finance_staff: "HQ Finance Staff",
	admin_blog: "HQ Admin Blog",

	franchise_owner: "Franchise Owner",
	business_owner: "Business Owner",
	finance_office: "Finance Office",
	manager_office: "Manager Office",
	admin_office: "Admin Office",
	agent: "Agent",
};

export const EMPLOYEE_ROLES_LEVELS = {
	level1: [
		"admin",
		"admin_general_manager",
		"admin_manager",
		"admin_hq",
		"admin_finance_gm",
		"admin_finance_manager",
		"admin_finance_staff",
		"admin_blog",
	],
	level2: ["franchise_owner", "business_owner", "manager_office", "finance_office", "admin_office"],
	level3: ["agent"],
};

export enum EEmployeeStatus {
	OPEN = "OPEN",
	ACTIVE = "ACTIVE",
	TRANSFERED = "TRANSFERED",
	TERMINATED = "TERMINATED",
}

export type EmployeeProperties = {
	employeeId: string;
	officeId?: string;
	userId: string;
	employeeCode?: string;
	allowSelfListing?: boolean;
	fixCodeCreatedAt?: Date;
	tempEmployeeCode?: string;
	tempCodeCreatedAt?: Date;
	slug?: string;
	isStarAgent?: boolean;
	starAgentWebContent?: string;
	agentCommission?: number;
	status: EEmployeeStatus;
	createdByUserId?: string;
	createdByUserMeta?: any;
	metadata?: any;
	currentPosition?: string;
	lastUpdateByMeta?: any;
	bioAuthor?: string;
	socialMedia?: any;
	slugAuthor?: string;
	createdAt?: Date;
	updatedAt?: Date;

	user?: UserProperties;
	profile?: ProfileProperties;
	eventParticipant?: EventParticipantProperties[];
	office?: OfficeProperties;
	employeeRole?: Omit<EmployeeRoleProperties, "employee">[];
	currentPositionItem?: MasterPositionProperties;
	closingSellCount?: number;
	closingRentCount?: number;
	transferEmployeeCount?: number;
	transferEmployeeLastDate?: string;
	starAgentPhoto?: FileProperties;
	agentBillings?: AgentBillingProperties[];
	agentFeeCharges?: AgentFeeChargeProperties[];
	agentCommissions?: AgentCommissionProperties[];
	starAgentItems?: AlbumItem;
	starAgentTitle?: string;
	totalListingCount?: string;

	emailPortals?: EmailPortal[];
	groupMembers?: GroupMemberProperties[];
	agentHistories?: AgentHistoryProperties[];
};

export type EmailPortal = {
	portalId: string;
	portalName: string;
	email: string;
};
export const initialEmployee: EmployeeProperties = {
	employeeId: "",
	userId: "",
	status: EEmployeeStatus.OPEN,
};

export type ListEmployeeQuery = {
	filterEmployeeId?: string;
	filterUserId?: string;
	filterRole?: string;
	filterRoleApprovalStatus?: string;
	filterOfficeId?: string;
	isStarAgent?: string;
	filterSlug?: string;
	filterStatus?: string;
	filterCreatedByUserId?: string;
	filterAgentBillingStatus?: string;
	filterAgentCommissionHasAgentBilling?: string;
	filterAgentFeeChargeHasAgentBilling?: string;
	filterAgentCommissionStatus?: string;
	searchAgentBillingNumber?: string;
	filterAgentBillingsCreatedAtStartAt?: string;
	filterAgentBillingsCreatedAtEndAt?: string;
	includeData?: string;
	filterActionStartAt?: Date;
	filterActionEndAt?: Date;
	sort?: string;
};

export interface EmployeeApprovalResponseProps
	extends BaseResponseProps<{
		isSuccess: boolean;
		message?: string;
	}> {}

export interface EmployeeWithGroupedCommission extends EmployeeProperties {
	groupedCommissions: GroupedCommission[];
}
